const { angular } = window;

angular.module('wcm.core').directive('scopeStub', function() {
  return {
    scope: true,
    restrict: 'A'
  };
});
